// extracted by mini-css-extract-plugin
module.exports = {"fixedHeaderContainer":"_131wh","innerHeaderText":"_34v5E","fixedHeaderAvatar":"_2ZmiD"};